export default __webpack_public_path__ + "52d4f0c52f2742b9037bbffd8acb9d6b.svg";